function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.98 25.994c3.57-.726 6.518-1.327 6.552-1.335l.062-.015-3.37-4.615a619.035 619.035 0 01-3.37-4.637c0-.012 3.48-11.056 3.5-11.095.007-.013 2.375 4.694 5.741 11.41l5.774 11.522.044.088H8.491l6.489-1.323zM2.125 24.586c0-.006 1.588-3.18 3.529-7.053l3.529-7.041L13.3 6.52c2.262-2.185 4.119-3.976 4.126-3.979a.912.912 0 01-.066.192l-4.47 11.026-4.39 10.83H5.311c-1.062.01-2.124.01-3.186-.003z",
  fill: "#0089D6"
})));